import { render, staticRenderFns } from "./herderList2.vue?vue&type=template&id=662ed6aa&scoped=true"
import script from "./herderList2.vue?vue&type=script&lang=js"
export * from "./herderList2.vue?vue&type=script&lang=js"
import style0 from "./herderList2.vue?vue&type=style&index=0&id=662ed6aa&prod&lang=scss&scoped=true"
import style1 from "./herderList2.vue?vue&type=style&index=1&id=662ed6aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662ed6aa",
  null
  
)

export default component.exports